import DomainCommon from './common'

const CallService = {
    history: () => new Promise((resolve, reject) =>
        DomainCommon.fetchGet({
            url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/call/ended`,
            resolve, reject
        })),
    incoming: () => new Promise((resolve, reject) =>
        DomainCommon.fetchGet({
            url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/call/todo`,
            resolve, reject
        })),
    fetchArchiveById: ({ archiveId }) => new Promise((resolve, reject) =>
        DomainCommon.fetchGet({
            url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/call/archive/${archiveId}`,
            resolve, reject
        })),
}

export default CallService



// WEBPACK FOOTER //
// ./src/service/call.js